import React, {useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom"
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Autocomplete from '@mui/joy/Autocomplete';
import { toast } from 'react-toastify';
import StatementService from "../../../services/statementService"


function ModalDocumentSend( {handleOpen, isOpen, refresh, listStatement, listAccounts}) {
    
    const initModel = {
        comitente: '',
        email: '',
        fullname : '',
        status : '',
        statement : '',
    }
    const initialized = useRef(false)
    const navigate = useNavigate();
    const [sending, setSending] = useState(false)
    const [sendModel, setSendModel] = useState(initModel)
    
    const newListAccounts = []
    listAccounts.forEach(data => newListAccounts.push(
        {
            id: data.id,
            account: data.account,
            name: data.name,
            emails: data.emails,
        }
    ))

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            setSendModel(initModel)
        }
    }, []);

    const doClose = async () => { 
        setSendModel(initModel)
        handleOpen(false) 
    }

    const selectComitente = async (obj) => {
        if(obj === null || obj === undefined || obj === ''){ 
            setSendModel({
                ...sendModel,
                comitente: '',
                email: '',
                fullname: '',
            })
        }else{
            setSendModel({
                ...sendModel,
                comitente: obj.account,
                email: obj.emails,
                fullname: obj.name,
            })
        }
        
    } 

    function validateNewForm (){
        let rta = true;
        if(sendModel.comitente === '' || sendModel.comitente === undefined  || sendModel.comitente === null){ return false; } 
        if(sendModel.email === '' || sendModel.email === undefined  || sendModel.email === null){ return false; } 
        if(sendModel.fullname === '' || sendModel.fullname === undefined  || sendModel.fullname === null){ return false; } 
        if(sendModel.statement === '' || sendModel.statement === undefined  || sendModel.statement === null){ return false; } 
        return rta;
    }

    const doSave = async () => {
        setSending(true)
        if(validateNewForm()){
            let model = {
                account: sendModel.comitente,
                name: sendModel.fullname,
                email: sendModel.email,
                note: sendModel.statement,
                sworn_statement_id: sendModel.statement,
            }
            console.log(model)
            
            StatementService.sendStatements(model)
            .then((response) => {
                toast.success('Notifiación enviada!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            })
            .catch((error) => {
                if(error.response.status !== 401){
                    toast.error(error.response.data.errors[0].detail, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            })
            .finally(() => { 
                setSending(false)
                refresh()
                doClose()
            })
        }else{
            setSending(false)
            toast.error('Cargue los datos correctamente!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } 

    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>Nuevo Envio</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}> 
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Notificación <span style={{color:'red'}}>*</span></FormLabel>
                                <select className="form-select" 
                                    value={sendModel.statement}
                                   onChange={(e)=> setSendModel({...sendModel, statement: e.target.value})}
                                >
                                    <option value="" key="null">Seleccione una Notificación</option>
                                    {listStatement.filter(st => st.active).map( (obj) => 
                                        <option value={obj.id} key={obj.id}>{obj.display_name}</option>
                                    )}
                                </select> 
                            </FormControl>
                        </Grid>
                        <Grid xs={12}>
                            <label className="form-label" htmlFor="basic-default-comitente">Seleccione Comitente <span style={{color:'red'}}>*</span></label>
                            <Autocomplete 
                                options={newListAccounts} 
                                getOptionLabel={option => option.name +' - '+ option.account }
                                slotProps={{
                                    listbox: {
                                        sx: (theme) => ({
                                        zIndex: theme.vars.zIndex.modal
                                        })
                                    }
                                }}
                                placeholder="Seleccione un Comitente" 
                                onChange={(event, newValue) => { selectComitente(newValue); }}
                            />  
                        </Grid>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Comitente</FormLabel>
                                <Input type="text" size="md" placeholder="" disabled={true} value={sendModel.comitente}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Nombre Completo</FormLabel>
                                <Input type="text" size="md" placeholder="" disabled={true} value={sendModel.fullname}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Email <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="text" size="md" placeholder="" value={sendModel.email} 
                                    onChange={(event) => {setSendModel({...sendModel, email: event.target.value}); }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info" onClick={() => doSave() } disabled={sending}>Confirmar</button>
                    <button type="button" className="btn btn-outline-secondary"  onClick={doClose}> Cerrar </button>                    
                </DialogActions>
            </ModalDialog>
        </Modal>
    );
}

export default ModalDocumentSend;